import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'share/:publicCode',
    title: 'Thumb Zone | Shared',
    loadComponent: () =>
      import('./link-preview/link-preview.component').then((c) => c.LinkPreviewComponent),
  },
];
